import React from 'react';
import Styled from 'styled';
import { useQuery } from '@apollo/client/react/hooks';
import { FormattedMessage } from 'react-intl';

import Select, { Style as SelectStyle } from 'four-nets/ui-v2/form/select/select';

import query, { ServicesSelectQuery } from './services-select.graphql';
import defaultStyles from './services-select.scss';

export interface Props {
    styles: typeof defaultStyles;
    selectStyles?: SelectStyle;
    onChange: (event: React.ChangeEvent<HTMLSelectElement>) => any;
    value?: string;
}

const ServicesSelect: React.FC<Props> = React.memo(props => {
    const { selectStyles = {} as SelectStyle, onChange, value = '' } = props;

    const { data } = useQuery<ServicesSelectQuery>(query);

    return data && data.services && data.services.edges && data.services.edges.length ? (
        <Select style={selectStyles} multiple={false} value={value} onChange={onChange}>
            <FormattedMessage id='CHOOSE_SERVICE_TYPE' values={{ gender: 'v' }}>
                {msg => (
                    <option disabled value='' key='default'>
                        {msg}
                    </option>
                )}
            </FormattedMessage>
            {data.services.edges.map(edge =>
                edge && edge.node ? (
                    <option value={edge.node.id} key={edge.node.id}>
                        {edge.node.name}
                    </option>
                ) : null
            )}
        </Select>
    ) : null;
});

export default Styled(defaultStyles)(ServicesSelect);
